// PrivateRoute.tsx
import React from "react";
import { Route, Navigate } from "react-router-dom";
import { useAuth } from "./../contexts/AuthContext";

interface PrivateRouteProps {
  element: React.ReactElement;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ element }) => {
  const { isAuthenticated } = useAuth();

  return isAuthenticated ? element : <Navigate to="/login" />;
};

export default PrivateRoute;
